import {
  STARDOG_EXPRESS_CONNECTION_NAME,
  STARDOG_EXPRESS_ENDPOINT,
} from 'src/common/constants/configuration';
import { initialState } from 'src/common/reducers/connection';
import { isStardogStudioWeb } from 'src/common/utils/isStardogStudioWeb';
import { safelyGet } from 'src/common/utils/safelyGet';
import { InitialData } from 'src/types';

const STARDOG_EXPRESS_PASSWORD = 'anonymous';
const baseExpressConnectionSansPassword = {
  ...initialState.current,
  name: STARDOG_EXPRESS_CONNECTION_NAME,
  username: 'anonymous',
  endpoint: STARDOG_EXPRESS_ENDPOINT,
};

// Restores erroneously deleted Stardog Express password on stardog.studio.
export default (data: InitialData) => {
  if (!isStardogStudioWeb) {
    return data;
  }

  const prevSavedExpressConnection = safelyGet(
    data,
    ['connection', 'saved', STARDOG_EXPRESS_CONNECTION_NAME],
    baseExpressConnectionSansPassword
  );
  const nextSavedExpressConnection = {
    ...prevSavedExpressConnection,
    password: STARDOG_EXPRESS_PASSWORD,
  };

  // Since this adds a saved Express connection in the (should-be-impossible)
  // case where it doesn't already exist, we also ensure consistency with
  // savedNames:
  const prevSavedConnectionNames = safelyGet(
    data,
    ['connection', 'savedNames'],
    []
  );
  const nextSavedConnectionNames = prevSavedConnectionNames.includes(
    STARDOG_EXPRESS_CONNECTION_NAME
  )
    ? prevSavedConnectionNames
    : [STARDOG_EXPRESS_CONNECTION_NAME, ...prevSavedConnectionNames];

  // And if the current connection is to Stardog Express, we update it there
  // as well.
  const prevCurrentConnection = safelyGet(
    data,
    ['connection', 'current'],
    initialState.current
  );
  const nextCurrentConnection =
    prevCurrentConnection.name === STARDOG_EXPRESS_CONNECTION_NAME
      ? {
          ...prevCurrentConnection,
          password: STARDOG_EXPRESS_PASSWORD,
        }
      : prevCurrentConnection;

  return {
    ...data,
    connection: {
      ...data.connection,
      current: nextCurrentConnection,
      saved: {
        ...data.connection.saved,
        [STARDOG_EXPRESS_CONNECTION_NAME]: nextSavedExpressConnection,
      },
      savedNames: nextSavedConnectionNames,
    },
    version: '1.34.1',
  };
};
